import React, { useState } from 'react';
import Header from './components/Header';
import UniversitySurveysCard from './components/UniversitySurveysCard';
import ParticipationCard from './components/ParticipationCard';
import GenderCard from './components/GenderCard';
import ChartCard from './components/ChartCard';
import BottomUniversitiesCard from './components/BottomUniversitiesCard';
import MonthlyReportCard from './components/MonthlyReportCard';
import { useDashboardStatistics } from './hooks/useDashboardStatistics';
import { Spin } from 'antd';
import 'src/styles/dashboard/new-dashboard.scss';

function AdminDashboardPage() {
  const [selectedUniversity, setSelectedUniversity] = useState<string>('');
  const [selectedTopic, setSelectedTopic] = useState<string>('');
  const [isCompleted, setIsCompleted] = useState<boolean | undefined>(undefined);

  // Hook orqali dinamik ma'lumotlarni olish
  const {
    loadingCharts,
    genderDistributionData,
    top10ByPercentage,
    bottom10ByPercentage,
    top10ByCompleted,
    bottom10ByCompleted,
    totalUsers,
    totalStudents,
    totalNotCompleted,
    maleUsers,
    femaleUsers,
    participatedUniversitiesCount,
    totalUniversitiesCount,
  } = useDashboardStatistics(
    selectedTopic ? Number(selectedTopic) : null,
    selectedUniversity || undefined,
    isCompleted
  );

  return (
    <div className="dashboard-container">
      <main className="main-dashboard">
        <Header
          onMenuClick={() => {}}
          selectedUniversity={selectedUniversity}
          setSelectedUniversity={setSelectedUniversity}
          selectedTopic={selectedTopic}
          setSelectedTopic={setSelectedTopic}
          isCompleted={isCompleted}
          setIsCompleted={setIsCompleted}
        />

        <Spin spinning={loadingCharts}>
          <div className="dashboard-content">
            {/* Top Three Charts Row */}
            <div className="top-three-charts">
              <div className="university-stat-card">
                <UniversitySurveysCard 
                  selectedTopic={selectedTopic} 
                  totalUsers={totalUsers}
                  totalStudents={totalStudents}
                  participatedUniversitiesCount={participatedUniversitiesCount}
                  totalUniversitiesCount={totalUniversitiesCount}
                />
              </div>
              <ParticipationCard
                selectedTopic={selectedTopic}
                setSelectedTopic={setSelectedTopic}
                selectedUniversity={selectedUniversity}
                totalUsers={totalUsers}
                totalStudents={totalStudents}
                totalNotCompleted={totalNotCompleted}
              />
              <GenderCard 
                selectedTopic={selectedTopic}
                genderDistributionData={genderDistributionData}
                maleUsers={maleUsers}
                femaleUsers={femaleUsers}
              />
            </div>

            {/* Monthly Report */}
            <div className="monthly-report-section">
              <MonthlyReportCard selectedQuizRuleId={selectedTopic ? Number(selectedTopic) : null} />
            </div>

            {/* Bottom Charts */}
            <div className="bottom-charts">
              <ChartCard 
                selectedTopic={selectedTopic}
                top10ByPercentage={top10ByPercentage}
                top10ByCompleted={top10ByCompleted}
              />
              <BottomUniversitiesCard 
                selectedTopic={selectedTopic}
                bottom10ByPercentage={bottom10ByPercentage}
                bottom10ByCompleted={bottom10ByCompleted}
              />
            </div>
          </div>
        </Spin>
      </main>
    </div>
  );
}

export default AdminDashboardPage;
